import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

const initialState = {
  handleView: sessionStorage.getItem("filestackModal") === "true",
};

const filestackSlice = createSlice({
  name: "filestackSlice",
  initialState,
  reducers: {
    changeValue(state, { payload }) {
      state.handleView = payload;
    },
    resetValue(state) {
      state.handleView = false;
    },
  },
});

export const { actions } = filestackSlice;
export default filestackSlice.reducer;

export const useFilestackActions = () => {
  const dispatch = useDispatch();

  const changeValue = (data) => {
    dispatch(filestackSlice.actions.changeValue(data));
  };
  const resetValue = () => {
    dispatch(filestackSlice.actions.resetValue());
  };

  return { changeValue, resetValue };
};
